var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconIndicators(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.688,
    height: 7.792,
    viewBox: "0 0 11.688 7.792",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_material-filter-list",
    "data-name": "Icon material-filter-list",
    d: "M9.045,16.792h2.6v-1.3h-2.6ZM4.5,9v1.3H16.188V9Zm1.948,4.545H14.24v-1.3H6.448Z",
    transform: "translate(-4.5 -9)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIndicators);
export default __webpack_public_path__ + "static/media/icon-indicators.ee91e62202553e33792bfb77be927e28.svg";
export { ForwardRef as ReactComponent };